import React from "react";
import { Modal } from "antd";
import DocumentUploadForm from "../pages/ClientPage/DocumentUploadForm";

const UploadDocumentModal = ({
  open,
  handleClose,
  patientId,
}) => {
  return (
    <Modal open={open} onCancel={handleClose} centered footer={null}  width={900}>
        <div>
          <DocumentUploadForm
            handleClose={handleClose}
            patientId={patientId}
          />
        </div>
    </Modal>
  );
};

export default UploadDocumentModal;